import React from "react";
import { Menu, Icon } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../stores/store";
import MobileLanguageSwitcher from "../Common/mobileLanguageSwitcher";

interface SideNavMenuProps {
  onClose: () => void;
}

export default observer(function SideNavMenu({ onClose }: SideNavMenuProps) {
  const { commonStore } = useStore();

  return (
    <>
      <Menu.Item className="lang-drop">
        <MobileLanguageSwitcher onLanguageSelected={()=>{onClose();}} />
      </Menu.Item>
      {commonStore.lang === "en" && commonStore.currentSurveyCode === "kh" && (
        <Menu.Item
          className="gloss-icn"
          as="a"
          href="/assets/RefleCT_Glossary_ENG_KH.pdf"
          target="_blank"
          rel="noopener noreferrer" // Recommended for security
          onClick={() => onClose()}
        >
          <Icon name="book" /> Glossary
        </Menu.Item>
      )}
      {commonStore.lang === "en" && commonStore.currentSurveyCode !== "kh" && (
        <Menu.Item
          className="gloss-icn"
          as="a"
          href="/assets/RefleCT_Glossary_ENG.pdf"
          target="_blank"
          rel="noopener noreferrer" // Recommended for security
          onClick={() => onClose()}
        >
          <Icon name="book" /> Glossary
        </Menu.Item>
      )}
      {commonStore.lang === "kh" && (
        <Menu.Item
          className="gloss-icn"
          as="a"
          href="/assets/RefleCT_Glossary_KH.pdf"
          target="_blank"
          rel="noopener noreferrer" // Recommended for security
          onClick={() => onClose()}
        >
          <Icon name="book" /> សន្ទានុក្រម
        </Menu.Item>
      )}
      {commonStore.lang === "ru" && (
        <Menu.Item
          className="gloss-icn"
          as="a"
          href="/assets/RefleCT_Glossary_RUS.pdf"
          target="_blank"
          rel="noopener noreferrer" // Recommended for security
          onClick={() => onClose()}
        >
          <Icon name="book" /> глоссарий
        </Menu.Item>
      )}
      {commonStore.lang === "uz" && (
        <Menu.Item
          className="gloss-icn"
          as="a"
          href="/assets/RefleCT_Glossary_UZB.pdf"
          target="_blank"
          rel="noopener noreferrer" // Recommended for security
          onClick={() => onClose()}
        >
          <Icon name="book" /> lug'at
        </Menu.Item>
      )}
      {commonStore.lang === "vn" && (
        <Menu.Item
          className="gloss-icn"
          as="a"
          href="/assets/RefleCT_Glossary_VN.pdf"
          target="_blank"
          rel="noopener noreferrer" // Recommended for security
          onClick={() => onClose()}
        >
          <Icon name="book" /> Bảng giải thích thuật ngữ
        </Menu.Item>
      )}
      {commonStore.lang === "id" && (
        <Menu.Item
          className="gloss-icn"
          as="a"
          href="/assets/RefleCT_Glossary_ID.pdf"
          target="_blank"
          rel="noopener noreferrer" // Recommended for security
          onClick={() => onClose()}
        >
          <Icon name="book" /> Daftar Istilah
        </Menu.Item>
      )}
    </>
  );
});
